import { Selector } from "@ngxs/store";
import { DateRestrictionTypes } from "../../interfaces/date-restriction-type.enum";
import { FilterState, FilterStateModel, FirmIdListState, FirmIdListStateModel } from "./filter.state";
import { FilterValueTypeEnum } from "../../interfaces/filter-value-type.enum";
import { FilterFlowTypeEnum } from "../../interfaces/filter-type.enum";
import { SelectedSubtreeVariablesState } from "../selected-subtree-variables/selected-subtree-variables.state";
import { SelectedVariablesStateModel } from "../selected-variables/selected-variables.state";

export class FilterGetterState {
  @Selector([FilterState])
  static getCurrentRestriction(state: FilterStateModel) {
    return state.currentRestriction;
  }

  @Selector([FilterState])
  static getCurrentFilter(state: FilterStateModel) {
    return state.currentFilter;
  }

  @Selector([FilterState])
  static getExcludeMetaOnlyFirms(state: FilterStateModel) {
    return state.excludeMetaOnlyFirms;
  }

  @Selector([FilterState])
  static getCurrentFilterCounts(state: FilterStateModel) {
    return state.currentFilterCounts;
  }

  @Selector([FilterState])
  static getIsCurrentFilterCountLoading(state: FilterStateModel) {
    return state.activeButNotSubmittedFilterCountsAreLoading && !!state.activeButNotSubmittedFiltersHash;
  }

  @Selector([FilterState])
  static getActiveButNotSubmittedFilterCountResult(state: FilterStateModel) {
    return state.activeButNotSubmittedFilterCountResult;
  }

  @Selector([FilterState])
  static getActiveButNotSubmittedFilterCountsProgress(state: FilterStateModel) {
    return state.activeButNotSubmittedFilterCountsProgress;
  }

  @Selector([FilterState, SelectedSubtreeVariablesState])
  static getIsSaveRestrictionDisabled(filterState: FilterStateModel, subtreeState: SelectedVariablesStateModel) {
    const {dateRestrictionType, dateRestrictionArgs, filterVariable, filterValueType, filterValue} = filterState.currentRestriction;
    const selectedSubtreeVariables = subtreeState.tags;

    return !filterVariable 
    || (filterVariable.filterFlowType === FilterFlowTypeEnum.search && !(filterValue?.length || filterValueType === FilterValueTypeEnum.nonmissing))
    || (filterVariable.filterFlowType === FilterFlowTypeEnum.tree && !(selectedSubtreeVariables?.length || filterValueType === FilterValueTypeEnum.nonmissing))
    || (filterVariable.filterFlowType === FilterFlowTypeEnum.treelist && !(selectedSubtreeVariables?.length || filterValueType === FilterValueTypeEnum.nonmissing))
    || (filterValueType === FilterValueTypeEnum.minmax && !(filterValue?.min || filterValue?.max))
    || ((dateRestrictionType === DateRestrictionTypes.inAllPeriods || dateRestrictionType === DateRestrictionTypes.inAnyPeriod) && !dateRestrictionArgs?.length);
  }

  @Selector([FilterState])
  static getFiltersPresetList(state: FilterStateModel) {
    return state.filtersPresetList;
  }

  @Selector([FilterState])
  static getFiltersPreset(state: FilterStateModel) {
    return {name: state.filtersPresetName, preset: state.filtersPreset, presetExcludeMetaOnlyFirms: state.filtersPresetExcludeMetaOnlyFirms};
  }

  @Selector([FilterState])
  static getLastFilterCount(state: FilterStateModel) {
    return state.activeButNotSubmittedFilterCountResult
  }

  @Selector([FilterState])
  static getServerSideEventHashes(state: FilterStateModel) {
    return state.serverSideEventHashes;
  }
}

export class FirmIdListGetterState {
  @Selector([FirmIdListState])
  static getFirmIdListPresetList(state: FirmIdListStateModel) {
    return state.firmIdListPresetList;
  }

  @Selector([FirmIdListState])
  static getFirmIdListPreset(state: FirmIdListStateModel) {
    return {name: state.firmIdListPresetName, preset: state.firmIdListPreset};
  }
}